import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

export const AffiliateLoginPage = (props) => {
  const { affiliateLogin, isAffiliateLoggedIn, isLoading } = props;
  const [searchParams] = useSearchParams();
  const redirection = searchParams.get("redirect_path");
  const [showPassword, setShowPassword] = useState(true);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if(isAffiliateLoggedIn) {
      if(redirection) {
        navigate(`/${redirection}`);
      } else {
        navigate("/affiliate-dashboard");
      }
    }
  }, [isAffiliateLoggedIn]);

  const onSubmit = (data) => {
    affiliateLogin(data);
  };

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">Affiliate Portal</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <Link to="/" className="text-white">Home</Link>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">Affiliate Login</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container d-flex justify-content-center align-items-center py-5">
        <div className="card p-4" style={{width: "100%", maxWidth: "600px"}}>
          <h4 className="mb-4" style={{fontWeight: 700, fontSize: "30px"}}>Affiliate / Influencer Login</h4>
          <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label text-secondary">Email address<span className="text-danger">*</span></label>
              <input type="text" name="username" {...register('username', { required: 'Email address is required' })} className="form-control" id="email" placeholder="Type Email Address"/>
              {errors.username && <p className="text-danger px-2">{errors.username.message}</p>}
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label text-secondary">Password<span className="text-danger">*</span></label>
              <div className="input-group">
                <input type={showPassword ? "password" : "text"} {...register('password', { required: 'Password is required' })} className="form-control" id="password" placeholder="Enter password" />
                <button className="btn btn-dark" type="button" id="togglePassword" onClick={() => setShowPassword(!showPassword)}>
                    <i className="bi bi-eye"></i>
                </button>
              </div>
              {errors.password && <div className="text-danger px-2">{errors.password.message}</div>}
            </div>
            <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 mb-3">
              <Link to="/become-an-affiliate" className="fw-bold" style={{ color: "#66a92f", textDecoration: "underline" }}>Join our Affiliate Program?</Link>
              <Link to="/affiliate-forget-password" className="text-decoration-none text-dark">Lost your password?</Link>
            </div>

            <button type="submit" disabled={isLoading} className="btn w-100"
              style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>
              {isLoading ? "Logging in..." : "Log in"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
